/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DnspDeviceControlIntervals } from "./DnspDeviceControlIntervals";
import {
    DnspDeviceControlIntervalsFromJSON,
    DnspDeviceControlIntervalsFromJSONTyped,
    DnspDeviceControlIntervalsToJSON,
} from "./DnspDeviceControlIntervals";

/**
 *
 * @export
 * @interface DnspControlIntervalsByDeviceResponse
 */
export interface DnspControlIntervalsByDeviceResponse {
    /**
     * List of all devices the DNSP controls. If no envelopes were specified for the date range, this will be 2 items, reflecting the default interval(s) by device type. If a single deviceId param was passed, then this will be that item only, or empty if the device does not exist.
     * @type {Array<DnspDeviceControlIntervals>}
     * @memberof DnspControlIntervalsByDeviceResponse
     */
    devices?: Array<DnspDeviceControlIntervals>;
    /**
     * The query `from` param. Equal to the start of the first intervals
     * @type {Date}
     * @memberof DnspControlIntervalsByDeviceResponse
     */
    from?: Date;
    /**
     * The query `to` param. Used as the end time of the last interval
     * @type {Date}
     * @memberof DnspControlIntervalsByDeviceResponse
     */
    to?: Date;
}

/**
 * Check if a given object implements the DnspControlIntervalsByDeviceResponse interface.
 */
export function instanceOfDnspControlIntervalsByDeviceResponse(
    value: object,
): value is DnspControlIntervalsByDeviceResponse {
    return true;
}

export function DnspControlIntervalsByDeviceResponseFromJSON(
    json: any,
): DnspControlIntervalsByDeviceResponse {
    return DnspControlIntervalsByDeviceResponseFromJSONTyped(json, false);
}

export function DnspControlIntervalsByDeviceResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DnspControlIntervalsByDeviceResponse {
    if (json == null) {
        return json;
    }
    return {
        devices:
            json["devices"] == null
                ? undefined
                : (json["devices"] as Array<any>).map(
                      DnspDeviceControlIntervalsFromJSON,
                  ),
        from: json["from"] == null ? undefined : new Date(json["from"]),
        to: json["to"] == null ? undefined : new Date(json["to"]),
    };
}

export function DnspControlIntervalsByDeviceResponseToJSON(
    value?: DnspControlIntervalsByDeviceResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        devices:
            value["devices"] == null
                ? undefined
                : (value["devices"] as Array<any>).map(
                      DnspDeviceControlIntervalsToJSON,
                  ),
        from: value["from"] == null ? undefined : value["from"].toISOString(),
        to: value["to"] == null ? undefined : value["to"].toISOString(),
    };
}
